/**
 * While running in Cypress, we want to slightly alter some behaviors to create a more predictable environment.
 *
 * An example of this are Lottie videos and animations. Most of these start playing immediately. The videos or
 * animations are captured by Percy with some milliseconds difference, which causes the snapshots to be flaky:
 * We'll always get a visual difference, even if it's one pixel. In this case, we might want to ensure all
 * Lottie videos and animations are frozen in Cypress.
 */
export default function inCypress(): boolean {
  return typeof window !== 'undefined' && !!window.Cypress
}
